module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Card_Visa-9f724f2730101bee2370de3f4626cb3c.gif";